import { render, staticRenderFns } from "./SysGatewayRouteList.vue?vue&type=template&id=6324ee0c&scoped=true&"
import script from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"
export * from "./SysGatewayRouteList.vue?vue&type=script&lang=js&"
import style0 from "./SysGatewayRouteList.vue?vue&type=style&index=0&id=6324ee0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6324ee0c",
  null
  
)

export default component.exports